import { GlobalAxios } from "../axios/axios-config";
import { IResSendNonLabWorklistYLog } from "../models/res-send-non-lab-worklist-y-log";

const RES_SEND_NON_LAB_WORKLIST_Y_LOG_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/ResSendNonLabWorklistY/ResSendNonLabWorklistLog";

export const getResSendNonLabWorklistYLog = (resSendIdentifier: number) => {
  return GlobalAxios.get<IResSendNonLabWorklistYLog>(
    RES_SEND_NON_LAB_WORKLIST_Y_LOG_ROUTE,
    {
      params: {
        resSendIdentifier,
      },
    },
  );
};
